import React ,{useEffect} from 'react';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import MissionMain from './MissionMain';

const Mission = () => {
  useEffect(() => {
      document.title = "Mission | Society of Aquaculture Professionals";
    }, []);
  return (
    <div>
      <>
        <Header />

        <MissionMain />

        <Footer />
      </>
    </div>
  );
};
export default Mission;
